import { Title, Subtitle, Button } from '~components'
import { usePreventBrowserBack, usePathValidation, useStore } from '~hooks'
import * as Styled from './styled'
import mobile from 'is-mobile'
import moment from 'moment'

function Difficulty() {
  const store = useStore()
  const isMobile = mobile()
  const message = `Olá, preciso de ajuda para recuperar a minha senha! Meu  CPF é ${store.cpf}. Poderia me ajudar?`

  usePathValidation(['cpf', 'passwordRecovery.blockedTime'])
  usePreventBrowserBack()

  function handleClickWhatsapp() {
    window.open(
      `https://api.whatsapp.com/send/?phone=551141181843&text=${encodeURI(
        message,
      )}&app_absent=0`,
      '_blank',
    )
  }
  function handleClickCall() {
    if (mobile()) window.open('tel:1130037182')
  }

  return (
    <>
      <Title>Dificuldades para recuperar a senha?</Title>
      <Subtitle>
        Você pode tentar entrar novamente às{' '}
        <Styled.Time>
          {moment(store?.passwordRecovery?.blockedTime).format('HH[h]mm')}
        </Styled.Time>{' '}
        ou falar com o nosso atendimento.
      </Subtitle>
      <Styled.Footer>
        <Button width="100%" onClick={handleClickWhatsapp}>
          Atendimento pelo WhatsApp
        </Button>
        {isMobile ? (
          <Styled.Button onClick={handleClickCall}>Ligar no (11) 3003-7182</Styled.Button>
        ) : (
          <Styled.SecondaryTypography>Ligar no (11) 3003-7182</Styled.SecondaryTypography>
        )}
      </Styled.Footer>
    </>
  )
}

export default Difficulty
